export default function() {
  return {
    isRequestInProgress: false,
    isCategoricalRequestInProgress: false,
    isSaveInProgress: false,
    isTemp: false,
    isPublic: false,
    magicLink: null,
  };
}
